import type { FaireProductEntity } from "../../entity_types/product";

export const p_yhnn7g48qg: FaireProductEntity = {
  token: "p_yhnn7g48qg",
  type: "product",
  name: "Soothing Baby Body Wash, Crème Douce, 16 oz",
  brandToken: "b_cf402a0d",
  brandName: "Noodle & Boo, Inc.",
  imageUrl: "https://cdn.faire.com/fastly/afbb6fd89de3b38ee18c93bbf94967d31fab13fe4474b0f8e4f592203332430f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ccee5416007a54546177f00c93307f6cb83202b14c6444e80929c5da8e834ed4.jpeg",
    "https://cdn.faire.com/fastly/3e550e0a5b4690db2a5ddc2141840c310060872dbd121aa4bf0a8f81922251d0.jpeg"
  ],
  priceDollars: 12.47,
  description: "Make bath time gentle and calming with our low-suds body wash designed for newborns and sensitive skin:\n•    Allantoin-enriched formula soothes tender skin, leaving it soft and comforted\n•    Gentle cleansing that won’t strip away natural moisture\n•    Soap-free blend rebalances skin’s natural pH while provitamin B5 and vitamin E condition and hydrate\n•    Can be poured directly into bath water for a moisturizing soak\n•    Tear-free and mild enough for daily use on newborns and babies with sensitive skin\n\nOur Promise:\n•    Hypoallergenic\n•    Pediatrician-tested & Dermatologist-tested\n•    Cruelty-free and Non-toxic\n•    Made in USA\n•    Free from Parabens, Phthalates, Sulfates, PPGs, and Dyes",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:08.652Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
